import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../../commonComponents/translate';
import FormInput from '../../../../../../commonComponents/forms/FormInput';
import ProfileField from '../../profile/ProfileField';
import FormSubtitle from '../../../../../../commonComponents/forms/FormSubtitle';
import CryptoWalletList from './components/CryptoWalletList';
import ImageInput from '../../../../../../commonComponents/forms/ImageInput';
import CryptoCurrencyNetworkProp from '../../../../../../commonComponents/propTypes/cryptoCurrencyNetworkProp';
import { PROFILE_BLOCK } from '../../../../../../services/utilityFunctions';
import RequiredFieldsPerBlockProp from '../../../../../../commonComponents/propTypes/requiredFieldsPerBlockProp';
import { isFieldRequiredLabel } from '../../../../helpers/helper';
import getBankFieldLabels from '../../../../../../services/bankFields';

function IndividualTab(props) {
  const {
    t,
    user,
    userInformation,
    onChange,
    onCryptoWalletChange,
    handleCryptoNetworkInformation,
    cryptoCurrenciesNetwork,
    onInitialImage,
    onImageChange,
    requiredFieldsPerBlock,
    onTaxChange,
    inputProps,
    vatPlaceholder,
    nifLabel,
  } = props;
  // Country-aware bank labels (IBAN/SWIFT vs CLABE/Account number) — BRAVON-6285.
  const bankLabels = getBankFieldLabels(
    user?.address?.countryCode || user?.shippingCountry,
  );
  return (
    <div className="individualTab">
      <ProfileField
        field="taxType"
        type="select"
        value={userInformation.taxCode}
        onChange={onTaxChange}
        inputProps={inputProps}
        placeholder={t('profile_taxType')}
        containerClassName="taxCodeWrapperContainer col-7"
        block={PROFILE_BLOCK.LEGAL_FINANCES}
        requiredFieldsPerBlock={requiredFieldsPerBlock}
      />
      <FormInput
        id="NIF"
        name="NIF"
        value={userInformation.NIF}
        labelClassName="col-lg-2 col-sm-12"
        containerClassName="col-lg-7 col-sm-12"
        onChange={change => onChange('NIF', change)}
        label={isFieldRequiredLabel(
          requiredFieldsPerBlock,
          PROFILE_BLOCK.LEGAL_FINANCES,
          'NIF',
          nifLabel,
        )}
        placeholder={
          vatPlaceholder.length > 0 ? vatPlaceholder : t('profile_NIF')
        }
        type="text"
        groupProps={{ className: 'row' }}
      />
      <ProfileField
        field="socialSecurityNumber"
        placeholder={t('profile_socialSecurityNumber')}
        value={userInformation.socialSecurityNumber}
        onChange={onChange}
        block={PROFILE_BLOCK.LEGAL_FINANCES}
        requiredFieldsPerBlock={requiredFieldsPerBlock}
      />
      <FormSubtitle title={t('bank_account')} />
      <ProfileField
        field="IBAN"
        labelKey={bankLabels.primaryKey}
        value={userInformation.IBAN}
        onChange={onChange}
        placeholder={t('profile_IBAN')}
        block={PROFILE_BLOCK.LEGAL_FINANCES}
        requiredFieldsPerBlock={requiredFieldsPerBlock}
      />
      {bankLabels.secondaryKey ? (
        <ProfileField
          field="SWIFT"
          labelKey={bankLabels.secondaryKey}
          value={userInformation.SWIFT}
          onChange={onChange}
          placeholder={t('profile_SWIFT')}
          block={PROFILE_BLOCK.LEGAL_FINANCES}
          requiredFieldsPerBlock={requiredFieldsPerBlock}
        />
      ) : null}
      <CryptoWalletList
        cryptoCurrenciesNetwork={cryptoCurrenciesNetwork}
        handleCryptoNetworkInformation={handleCryptoNetworkInformation}
        onCryptoWalletChange={onCryptoWalletChange}
        userInformation={userInformation}
        requiredFieldsPerBlock={requiredFieldsPerBlock}
      />
      <FormSubtitle title={t('profile_identification')} />
      <ProfileField
        field="cardId"
        value={userInformation.cardId}
        onChange={onChange}
        placeholder={t('profile_cardId')}
        inputField="id"
        nameField="id"
        block={PROFILE_BLOCK.LEGAL_FINANCES}
        requiredFieldsPerBlock={requiredFieldsPerBlock}
      />
      <ImageInput
        id="cardFront"
        inputId="cardFrontInput"
        name="cardFront"
        initialValue={onInitialImage(user, 'front')}
        onChange={onImageChange('cardFront')}
        inputProps={{ cropAspect: 1.618 }}
        label={t('profile_cardFront')}
      />
      <ImageInput
        id="cardBack"
        inputId="cardBackInput"
        name="cardBack"
        initialValue={onInitialImage(user, 'back')}
        onChange={onImageChange('cardBack')}
        inputProps={{ cropAspect: 1.618 }}
        label={t('profile_cardBack')}
      />
    </div>
  );
}

IndividualTab.propTypes = {
  t: PropTypes.func.isRequired,
  user: PropTypes.shape({}).isRequired,
  userInformation: PropTypes.shape({
    NIF: PropTypes.string.isRequired,
    taxCode: PropTypes.string.isRequired,
    SIREN: PropTypes.string.isRequired,
    socialSecurityNumber: PropTypes.string.isRequired,
    SWIFT: PropTypes.string.isRequired,
    IBAN: PropTypes.string.isRequired,
    cardId: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onCryptoWalletChange: PropTypes.func.isRequired,
  handleCryptoNetworkInformation: PropTypes.func.isRequired,
  cryptoCurrenciesNetwork: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.shape(CryptoCurrencyNetworkProp.propType)),
  ).isRequired,
  onImageChange: PropTypes.func.isRequired,
  onInitialImage: PropTypes.func.isRequired,
  requiredFieldsPerBlock: PropTypes.arrayOf(
    PropTypes.shape(RequiredFieldsPerBlockProp.propType),
  ),
  onTaxChange: PropTypes.func.isRequired,
  inputProps: PropTypes.func.isRequired,
  vatPlaceholder: PropTypes.string,
  nifLabel: PropTypes.string.isRequired,
};
IndividualTab.defaultProps = {
  requiredFieldsPerBlock: RequiredFieldsPerBlockProp.defaultProp,
  vatPlaceholder: '',
};

export default translate(IndividualTab);
